import { Bar, ErrorState, Loading } from "@/components/ui";
import { IosGroup, IosSection } from "@/components/mobile/MobileUi";
import { ArrivalsMonths, ArrivalsSummary } from "@/components/widgets";
import { useSelectedBoutique } from "@/hooks/useSelectedBoutique";
import { useBoutiqueArrivals } from "@/lib/queries";
import { eur } from "@/lib/format";

/** Arrivages mobile : récap, historique par mois (détail au toucher), fournisseurs de la boutique choisie. */
export function MobileArrivals() {
  const { selectedId } = useSelectedBoutique();
  const q = useBoutiqueArrivals(selectedId ?? undefined);
  if (q.isLoading) return <Loading />;
  if (q.error) return <ErrorState error={q.error} />;
  if (!q.data) return null;
  const d = q.data;
  return (
    <div className="flex flex-col gap-3">
      <ArrivalsSummary data={d} />
      <ArrivalsMonths data={d} compact />
      {d.suppliers.length > 1 && (
        <IosSection title="Répartition par fournisseur">
          <IosGroup className="px-4 py-1">
            {d.suppliers.map((f) => (
              <div key={f.name} className="border-b-[0.5px] border-ios-sep py-[11px] last:border-b-0">
                <div className="flex justify-between gap-3 text-[15px]">
                  <span className="min-w-0 truncate">{f.name}</span>
                  <span className="flex-shrink-0 font-semibold tabular">
                    {Math.round(f.pct)} % · {eur(f.amount)}
                  </span>
                </div>
                <Bar pct={f.pct} className="mt-[6px]" track="bg-ios-fill" />
              </div>
            ))}
          </IosGroup>
        </IosSection>
      )}
    </div>
  );
}
